import { ServicesPage } from "./Services";
export default ServicesPage;
